export enum PlateIdTypes {
	SOURCE = "SOURCE",
	LYSIS = "LYSIS",
	MAGMIX = "MAGMIX",
	DNA = "DNA",
	ALIQUOT = "ALIQUOT",
	WGA = "WGA",
	PGX = "PGX",
	LAST_UPDATED_PLATEID = "LUP",
}

export enum PlateType {
	PLATE = "PLATE",
	BEADCHIP = "BEADCHIP"
}